import React from 'react'

const SvgOpenInNewTabOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M9 5c0 .35.06.687.17 1H6v12h12v-3.17a2.997 2.997 0 002 0V18a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h3.17c-.11.313-.17.65-.17 1z' />
    <path d='M13 4a1 1 0 100 2h3.586l-5.293 5.293a1 1 0 001.414 1.414L18 7.414V11a1 1 0 102 0V5a1 1 0 00-1-1h-6z' />
  </svg>
)

export default SvgOpenInNewTabOutline
